import { gerar_arquivo_texto_de_docentes_com_cpf } from "./gerar-arquivo-texto-de-docentes-com-cpf/index";
import { gerar_arquivo_texto_de_gestores_com_cpf } from "./gerar-arquivo-texto-de-gestores-com-cpf/index";
import { gerar_arquivo_texto_de_alunos_com_cpf } from "./gerar-arquivo-texto-de-alunos-com-cpf/index";
import { resumo_de_alunos_de_transporte_escolar } from "./resumo-de-alunos-de-transporte-escolar/index";
import { emitir_relatorio_de_alunos_com_informacoes_pendentes } from "./emitir-relatorio-de-alunos-com-informacoes-pendentes/index";
import { emitir_relatorio_de_docentes_com_informacoes_pendentes } from "./emitir-relatorio-de-docentes-com-informacoes-pendentes";
import { emitir_relatorio_de_escolas_com_informacoes_pendentes } from "./emitir-relatorio-de-escolas-com-informacoes-pendentes";

const relatorio_de_acompanhamento_do_censo_escolar = [
  ...gerar_arquivo_texto_de_alunos_com_cpf,
  ...gerar_arquivo_texto_de_docentes_com_cpf,
  ...gerar_arquivo_texto_de_gestores_com_cpf,
  ...resumo_de_alunos_de_transporte_escolar,
  ...emitir_relatorio_de_alunos_com_informacoes_pendentes,
  ...emitir_relatorio_de_docentes_com_informacoes_pendentes,
  ...emitir_relatorio_de_escolas_com_informacoes_pendentes,
];

export { relatorio_de_acompanhamento_do_censo_escolar };
